import { Device } from 'DeviceUtils';
import Theme from 'Theme';
import React from 'react';
import { Linking, Platform, useWindowDimensions } from 'react-native';


const HTML = Platform.select({
    default: require('react-native-render-html').RenderHTML,
    // web: ({ source, baseStyle }) =>
    //     <div style={baseStyle} dangerouslySetInnerHTML={{ __html: source.html }} />
});

const renderHTMLText = (htmlText, textStyle = {}, tagStyle = {}) => {
    const renderLink = ({ TDefaultRenderer, ...props }) => {
        const href = props.tnode?.attributes?.href;
        if (href) {
            const handleLinkPress = () => {
                // const link = href.includes('http://') ? href : `http://${href}/`;
                if (Device.isPhone || Device.isTablet) {
                    return Linking.openURL(href);
                }
                return window.open(href, '_blank');
            };

            return (
                <TDefaultRenderer
                    onPress={handleLinkPress}
                    {...props}
                />
            );
        }
        return (<TDefaultRenderer {...props} />);
    };

    const tagsStyles = {
        p: { color: 'white' },
        b: { fontFamily: Theme.ultraFont },
        ...tagStyle
    };

    const renderers = { a: renderLink };
    const { width } = useWindowDimensions();
    return (
        <HTML
            contentWidth={width}
            source={htmlText}
            tagsStyles={tagsStyles}
            renderers={renderers}
            baseStyle={{
                fontFamily: Theme.regularFont,
                fontSize: Theme.fontSizes.description,
                color: Theme.primaryTextColor,
                textAlign: 'center',
                ...textStyle
            }}
        />
    );
};

export default renderHTMLText;
